export default "__VITE_ASSET__CieukZkg__"